// Referrals block schema - Share referral link with visitors
export const referralsSchema = {
  type: 'referrals',
  label: 'Referrals',
  description: 'Share your referral link with visitors',
  icon: 'UserPlus',
  defaultContent: {
    heading: 'Join ChessWeb',
    description: 'Create your own chess website for free!',
    buttonText: 'Sign Up',
    showShareButtons: true,
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Heading', type: 'text', placeholder: 'Join ChessWeb' },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'buttonText', label: 'Button Text', type: 'text', placeholder: 'Sign Up' },
  ],
};
